import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsTemplateRefPipe } from '@shared/ui/tooltip/browser/tooltip-renderer/internal/is-template-ref.pipe';

@NgModule({
  declarations: [IsTemplateRefPipe],
  imports: [CommonModule],
  exports: [IsTemplateRefPipe]
})
export class IsTemplateRefModule {}
